import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { ClearAllHeader, Person } from './molecules';
import { DropdownSearchInput, DropdownTextButton } from 'molecules';
import { Label, FilterCounter, Icon, SecondaryTextSm } from 'atoms';
import {
  FilterHeaderWrapper, StaticWrapper, FlexCenterWrapper,
  ScrollableDropdownBodyWrapper, DropdownContentWrapper,
  FullWidthRowCenterScrollWrapper, Mr2, GenericWrapper,
  Mt3, Ml3, P4
} from 'wrappers';
import { DownCaretSvg } from 'components/icons';
import internalState from './internalState';

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'MultiPersonSelector',
  controller: Controller,
  initialProps: ({ persons, selectedPersonsIds, scrollLeft, label, isSingleSelect }) => ({
    persons, selectedPersonsIds, label, left: (headerRef?.current?.offsetLeft ?? 0) - (scrollLeft ?? 0), isSingleSelect
  }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'Selector',
      ref: headerRef,
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              component: Label,
              name: 'Label',
              displayValue: ({ label }) => label ? label : 'Name: ',
            },
            {
              wrapper: FullWidthRowCenterScrollWrapper,
              name: 'ButtonList',
              elements: [
                {
                  component: DropdownTextButton,
                  name: 'PersonButton',
                  isListOf: 'selectedPersonsIds',
                  bindings: ({ selectedPersonsId, selectedPersonsIds, persons }) => {
                    return { text: persons.find(p => p.person_id === selectedPersonsId)?.name ?? '', selectedPersonsId, selectedPersonsIds }
                  }
                },
              ]
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'RightSideWrapper',
          elements:
            [
              {
                component: wrap(FilterCounter, Mr2),
                name: 'Counter',
                renderIf: ({ isSingleSelect }) => !isSingleSelect,
                displayValue: ({ selectedPersonsId }) => selectedPersonsId?.length ?? 0
              },
              {
                component: Icon,
                name: 'DownCaretSvg',
                displayValue: () => DownCaretSvg({}),
                bindings: () => ({})
              }
            ]
        }
      ]
    },
    {
      wrapper: ScrollableDropdownBodyWrapper,
      name: 'Body',
      ref: containerRef,
      displayState: ({ left }) => ({ left }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: ClearAllHeader,
          name: 'ClearAllHeader',
          renderIf: ({ isSingleSelect }) => !isSingleSelect,
          bindings: ({ selectedPersonsIds, persons }) => ({ selectedPersonsIds, persons })
        },
        {
          component: DropdownSearchInput,
          name: 'Search',
          bindings: ({ searchTerm }) => ({ value: searchTerm, placeholder: "Search" })
        },
        {
          component: wrap(SecondaryTextSm, P4),
          name: 'NoPersonText',
          renderIf: ({ persons }) => persons.length === 0,
          displayValue: ({ }) => 'No data is available'
        },
        {
          wrapper: DropdownContentWrapper,
          name: 'Properties',
          elements: [
            {
              wrapper: GenericWrapper,
              name: 'GroupWrapper',
              isListOf: {
                group: ({ persons }) => {
                  let groups = [];
                  persons.map(p => {
                    let groupIndex = groups.findIndex(g => g.id === p.type);
                    if (groupIndex < 0) {
                      groups.push({ id: p.type, persons: [p] })
                    } else {
                      groups[groupIndex].persons.push(p)
                    }
                  });
                  return groups;
                }
              },
              elements: [
                {
                  component: wrap(wrap(Label, Mt3), Ml3),
                  name: 'GroupSeparator',
                  displayValue: ({ group }) => group.id
                },
                {
                  component: Person,
                  name: 'Person',
                  isListOf: 'group.persons',
                  renderIf: ({ person, searchTerm }) => (new RegExp(searchTerm, 'i')).test(person.name),
                  bindings: ({ person, selectedPersonsIds, isSingleSelect }) => {
                    const isSelected = selectedPersonsIds.includes(person.person_id);
                    return { person, isSelected, selectedPersonsIds, isSingleSelect }
                  },
                  displayState: ({ person, selectedPersonsIds }) => ({ isSelected: selectedPersonsIds.includes(person.person_id) })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), StaticWrapper);

